import { ReactNode } from 'react';

const Text = ({ children }: { children: ReactNode }) => (
    <p className="landing-container__text">{children}</p>
);

export default Text;
